// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"443":"05e0cacd","722":"31d6cfe0","892":"291e2106","953":"05e0cacd"}[chunkId] + ".chunk.css";
};